<template>
  <footer id="footerACS">
    <div class="container-fluid bg2">
      <div class="row ml-2">
        <!-- <div class="text-white mt-pt-3"> -->
        <h1 class="text-white mt-4"><strong>Follow Us On</strong></h1>
        <!-- <div class="mt-4"> -->
      </div>
      <div class="row">
        <!-- <hr class="clearfix w-50 d-md-none pb-3"> -->
        <div class="col-md-8 ml-4">
          <!-- <hr class="clearfix w-50 d-md-none pb-3"> -->
          <div class="social-title">
            <h3 class="text-white">Our Social Media</h3>
            <div class="social-link h-100">
              <a href="https://www.instagram.com/">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/">
                <i class="fab fa-facebook"></i>
              </a>
              <a href="https://twitter.com/">
                <i class="fab fa-twitter"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <hr class="clearfix d-md-none" />
          <h6 class="text-uppercase text-white"><strong>HEAD OFFICE :</strong></h6>
          <ul class="list-unstyled">
            <li class="text-white">
              <hr class="clearfix d-md-none" />
              <br />
              Jl. Pisangan Timur Blok T <br />Pergudangan Tigaraksa Cipinang <br />Jakarta
              Timur 13230 Indonesia <br />Phone : +62 21 4788 4142 <br />Fax : +62 21 470
              3271
            </li>
          </ul>
        </div>
      </div>
      <!-- </div> -->
      <div class="footer-copyright text-center pb-5 text-white">
        <p>
          <strong
            >© 2021 Copyright: Adofagio Cinta Sejati and related mark are registered
            trademarks of PT. Adofagio Cinta Sejati</strong
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "CakiACS",
};
</script>

<style>
.full-width-menu.show {
  position: sticky !important;
  top: 50px;
  left: 0;
  width: 100%;
}
#footerACS .bg2 {
  background: #1F1F1F;
}
/* Style all font awesome icons */
.fab {
  color: white;
  margin-left: 0px;
  margin-right: 15px;
  padding: 10px;
  font-size: 30px;
  width: 30px;
  text-align: left;
  text-decoration: none;
}

/* Add a hover effect if you want */
.fab :hover {
  opacity: 2;
}

/* Set a specific color for each brand */

/* Instagram */
.fa-Instagram {
  background: #0b599d;
  color: white;
}
/* Facebook */
.fa-Facebook {
  background: #0b599d;
  color: white;
}
/* Twitter */
.fa-Twitter {
  background: #0b599d;
  color: white;
}
</style>
